const chainExplorers: Record<number, { name: string; url: string }> = {
  4337: { name: 'Beam Explorer', url: 'https://subnets.avax.network/beam' },
  13337: { name: 'Beam Testnet Explorer', url: 'https://subnets-test.avax.network/beam' },
  13371: { name: 'Immutable Explorer', url: 'https://explorer.immutable.com' },
  13473: { name: 'Immutable Testnet Explorer', url: 'https://explorer.testnet.immutable.com' },
  50104: { name: 'Sophon Explorer', url: 'https://explorer.sophon.xyz' },
  531050104: { name: 'Sophon Testnet Explorer', url: 'https://explorer.testnet.sophon.xyz' },
};

const getChainExplorer = (chainId: number) => {
  const explorer = chainExplorers[chainId];
  if (!explorer) throw new Error('Unsupported or invalid chain id');
  return explorer;
};

export const getChainExplorerName = (chainId: number) => getChainExplorer(chainId).name;

export const getChainExplorerUrl = (chainId: number, address: string, type: 'address' | 'tx') =>
  `${getChainExplorer(chainId).url}/${type}/${address}`;
